module.exports = __webpack_public_path__ + "img/3.d2766c9f.png";